import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    marginTop: '-8px',
  },
});

export default useStyles;
